import React from "react";
import { T } from "../../../app/tokens.js";
import { leaseMonthlyDisplay, MONTHLY_ACTUAL_NOTE } from "../../../../shared/leaseMonthlyDisplay.js";
import { convertAmount } from "../../../utils/fxConvert.js";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function MonthlyActualRentDetail({ lease, row, displayCurrency, rates }) {
  const months = MONTHS.map((_, index) => leaseMonthlyDisplay(lease.areas, row.year, index + 1,
    lease.currency, row.contractual, row.currency, lease));
  const first = months[0];
  if (first.basis !== "monthly_actual") return <div data-testid={`monthly-actual-status-${row.year}`}>
    {first.basis === "not_in_source" ? "Monthly payable: not in source for this year." : `Monthly payable unavailable: ${first.issue || "unresolved evidence"}.`}
  </div>;
  const format = (month) => {
    const converted = convertAmount(month.amount, month.currency, displayCurrency, rates);
    return converted == null ? "Unavailable" : new Intl.NumberFormat("en-US", {
      style: "currency", currency: displayCurrency, minimumFractionDigits: 2, maximumFractionDigits: 2,
    }).format(converted);
  };
  return <div data-testid={`monthly-actual-detail-${row.year}`} style={{ fontSize: T.fsXs, color: T.mid }}>
    <div>{MONTHLY_ACTUAL_NOTE}</div>
    <div data-testid={`rent-schedule-month-strip-${row.year}`}
      style={{ display: "grid", gridTemplateColumns: "repeat(12, minmax(90px, 1fr))", gap: 5, overflowX: "auto", marginTop: 8 }}>
      {months.map((month, index) => <div key={month.month}
        data-testid={`rent-schedule-month-${row.year}-${month.month}`} data-month-source="monthly_actual"
        data-sourced={String(month.sourced)} data-native-amount={month.amount}
        title={month.sourced ? `Source: ${month.source} · ${month.amount} ${month.currency}`
          : "No sourced payment this month; display-only zero"}
        style={{ border: `1px solid ${T.border}`, borderRadius: 4, padding: "6px 3px", textAlign: "center", background: T.card }}>
        <div>{MONTHS[index]}</div>
        <strong style={{ display: "block", color: T.dark, marginTop: 3 }}>{format(month)}</strong>
      </div>)}
    </div>
    {lease.leaseIdSpacebase === "xUXQY" && <div style={{ marginTop: 8 }}>
      Data note: AUH has multiple suites. Sourced payments can predate the single recorded lease start; all payments are retained.
    </div>}
  </div>;
}
